import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

import AppButton from "components/app-button";
import hero from "assets/images/components/pages/signup/exclamation.png";

export const AppEmailExistModal = (props, ref) => {
    const [visible, setVisible] = useState(false);

    const onHandleShow = useCallback(() => {
        setVisible(true);
    }, []);

    const onHandleDismiss = useCallback(() => {
        setVisible(false);
    }, []);

    //prettier-ignore
    useImperativeHandle(ref, () => ({
        onHandleShow: onHandleShow,
        onHandleDismiss: onHandleDismiss,
    }));

    return (
        <Modal classes={{ root: "app-email-exist" }} open={visible} aria-labelledby="email-exist" aria-describedby="email-exist-modal">
            <div className="email-exist">
                <img className="email-exist__hero" src={hero} alt="hero" />

                <div className="email-exist__header">
                    <p className="email-exist__title">Error</p>
                    <p className="email-exist__description">Email address is already exists.</p>
                </div>

                <div className="email-exist__button-container">
                    <AppButton type="button" label="Okay" onClick={onHandleDismiss} />
                </div>
            </div>
        </Modal>
    );
};

export default memo(forwardRef(AppEmailExistModal));

AppEmailExistModal.propTypes = {
    ref: PropTypes.object,
};
